module.exports = __webpack_public_path__ + "static/warning_announce-7edef73cac0c69a361f9741ef45689d9.png";